import { useTheme } from "../ThemeProvider";
import usePermiso from "../../hooks/usePermiso";
import { usePropiedadUi } from "../../hooks/usePropiedadUi";

const CAMPOS = [
  ["Registro", "ns_registro"],
  ["Tomo", "ns_tomo"],
  ["Libro", "ns_libro"],
  ["Folio", "ns_folio"],
  ["Finca", "ns_finca"],
  ["Inscripción", "ns_inscripcion"],
];

export default function SeccionNotaSimple(props) {
  const { form, cambiar } = props;
  const { tv } = usePropiedadUi(props);
  const { theme } = useTheme();
  const c = theme.colors;
  const isDark = theme.name === "dark";
  const { puede } = usePermiso();
  const puedeVerNotaSimple = puede("notasimple", "ver");
  const puedeModificarNotaSimple = puede("notasimple", "modificar");

  if (!puedeVerNotaSimple) return null;

  const labelStyle = {
    fontSize: 11, fontWeight: 600, color: c.textMuted,
    textTransform: "uppercase", letterSpacing: "0.04em",
    marginBottom: 6, display: "block",
  };
  const inputStyle = {
    padding: "8px 12px", border: `1px solid ${c.chipBorder}`,
    borderRadius: 8, fontSize: 13, color: c.textPrimary,
    background: isDark ? "#0a0e16" : "#dceeff", width: "100%", outline: "none",
    boxShadow: isDark
      ? "inset 0 3px 6px rgba(0,0,0,0.5), inset 0 1px 3px rgba(0,0,0,0.3)"
      : "inset 0 3px 6px rgba(100,140,200,0.18), inset 0 1px 3px rgba(80,120,180,0.13)",
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 12 }}>
      {CAMPOS.map(([label, name]) => (
        <div key={name}>
          <label style={labelStyle}>{tv(label)}</label>
          <input
            type="text"
            name={name}
            value={form[name] || ""}
            onChange={cambiar}
            disabled={!puedeModificarNotaSimple}
            title={!puedeModificarNotaSimple ? "No tienes permiso para modificar" : undefined}
            style={{ ...inputStyle, opacity: puedeModificarNotaSimple ? 1 : 0.6, cursor: puedeModificarNotaSimple ? "text" : "not-allowed" }}
          />
        </div>
      ))}
    </div>
  );
}
